import React from 'react';
import useBodyClass from 'helpers/hooks/useBodyClass';
import { createContentForTabs } from './utils';
import { ContentItem } from './Guides.types';
import GuidesComponent from 'components/Guides';

const Guides: React.FC = () => {
  useBodyClass('light');

  const config = [
    { label: 'All', isDisabled: false, id: 'All' },
    { label: 'Guides', isDisabled: false, id: 'Guides' },
    { label: 'Terms', isDisabled: true, id: 'Terms' },
    { label: 'Checklists', isDisabled: true, id: 'Checklists' },
  ];

  const content: ContentItem[] = [
    {
      url: '/static/assets/docs/Vulnerable_Customers_Guide_LiveMore_V4.pdf',
      heading: 'Vulnerable customers guide',
      description: 'Learn more about what we do to support vulnerable customers',
      category: 'guides',
    },
    {
      url: '/static/assets/docs/LiveMore_Affordability_Guide_Final.pdf',
      heading: 'Affordability guide',
      description: 'Learn more about our affordability assessment',
      category: 'guides',
    },
  ];

  const contentForTabs = createContentForTabs(content);
  const tabs = [contentForTabs.all, contentForTabs.guides, contentForTabs.terms, contentForTabs.checklist];

  return <GuidesComponent tabsConfig={config} tabs={tabs} />;
};

export default Guides;
